// 하단메뉴 데이터
export const bMenu = [
  {
      txt:"support",
      sub:[
        {
            txt: "고객지원센터",
            link: "#",
        },
        {
            txt: "1:1문의",
            link: "#",
        },
        {
            txt: "주문/배송 조회",
            link: "#",
        },
    ],
  },
  {
      txt:"information",
      sub:[
          {
              txt: "컨버스에 대하여",
              link: "#",
          },
          {
              txt: "회원가입",
              link: "#",
          },
          {
              txt: "매장안내",
              link: "#",
          },
          {
              txt: "공지사항",
              link: "#",
          },
      ],
  },
  {
      txt:"policy",
      sub:[
        {
            txt: "이용약관",
            link: "#",
        },
        {
            txt: "개인정보처리방침",
            link: "#",
        },
    ],
  },
  {
      txt:"family sites",
      sub:[
        {
            txt: "nike",
            link: "#",
        },
        {
            txt: "jordan",
            link: "#",
        },
    ],
  },
];